import { Link } from "react-router-dom";
import { Tab as TabComponent } from "@headlessui/react";
import { TabItem } from "./types";
import { Button } from "../button";
import { OverflowDisplayTooltip } from "../Tooltip/OverflowDisplayTooltip";
import { XIcon } from "@heroicons/react/solid";

export const Tab = ({
  tab,
  index,
  currentIndex,
  handleTabChange,
  isDragging,
}: {
  tab: TabItem;
  index: number;
  currentIndex: number;
  handleTabChange?: (id: number) => void;
  isDragging: boolean;
}) => {
  return (
    <TabComponent
      as={Link}
      to={tab.path || "#"}
      onClick={(e) => {
        if (!tab.path) {
          handleTabChange?.(tab.id);
          e.preventDefault();
        }
        tab.onClick?.(e);
      }}
      className={`relative flex h-10 cursor-grab items-center border-b-2 px-4 py-2.5 text-sm font-medium outline-none transition-colors duration-300 ease-in-out
                ${isDragging ? "bg-gray-100 opacity-80 shadow-md" : ""}
                ${
                  currentIndex === index + 2
                    ? "border-blue-600 text-blue-600 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:translate-y-[2px] after:bg-blue-600/20 after:blur-sm"
                    : "border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                } ${tab.className || ""}`}
      aria-label={`${tab.name} tab`}
    >
      <span className="flex max-w-[180px] items-center gap-2">
        <span className="min-h-4 min-w-4 max-w-4 relative max-h-4">
          <span
            className={`absolute inset-0 text-blue-400 transition-opacity duration-300 ${
              currentIndex === index + 2 ? "opacity-100" : "opacity-0"
            }`}
          >
            {tab.solidIcon}
          </span>
          <span
            className={`absolute inset-0 text-gray-400 transition-opacity duration-300 ${
              currentIndex === index + 2 ? "opacity-0" : "opacity-100"
            }`}
          >
            {tab.outlineIcon}
          </span>
        </span>
        <OverflowDisplayTooltip content={tab.name}>
          <span className="truncate">{tab.name}</span>
        </OverflowDisplayTooltip>
        {tab.onClose && (
          <Button
            variant="ghost"
            size="icon"
            className="!p-0 transition-all duration-100 ease-in-out hover:bg-transparent hover:text-red-500"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              tab.onClose?.(tab.id);
            }}
          >
            <XIcon className="h-3.5 w-3.5" />
          </Button>
        )}
      </span>
    </TabComponent>
  );
};
